import { useDealItemPicker } from './DealItemPicker';
import { useModal } from 'components/modal/ModalStack';
import { classNames, useEffect, useState } from 'libs/react';
import { DealItemPickerPackageDetail } from './DealItemPickerPackageDetail';
import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { Money } from 'components/Money';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { calculatePriceCurrency } from 'helpers/Pricing';
import { FormInput } from 'components/form/FormInput';
import { FormGroup } from 'components/form/FormGroup';
import { FormIconCheckBox } from 'components/form/FormIconCheckBox';
import './DealItemPickerPackageItem.scss';
/**
 * @component DealItemPickerPackageItem
 * @since 1.0.0
 */
export function DealItemPickerPackageItem(props) {
    var _a, _b;
    const { style, data } = Object.assign({ style: 'normal' }, props);
    const modal = useModal();
    const { packages, appendPackage, removePackage, appendOption, removeOption, deal, quantityType, quantity, alternativeTo } = useDealItemPicker();
    const [packageQuantity, setPackageQuantity] = useState((_b = (_a = packages.find((pack) => pack.package.id == data.package.id)) === null || _a === void 0 ? void 0 : _a.quantity) !== null && _b !== void 0 ? _b : 0);
    const [quantityAlert, setQuantityAlert] = useState(false);
    const [currentSelections, setCurrentSelections] = useState([]);
    let selectedIds = packages
        .filter((p) => p.quantity > 0)
        .map((pack) => pack.package.id);
    useEffect(() => {
        const pack = packages.find((entry) => entry.package.id == data.id);
        if (pack) {
            setPackageQuantity(pack.quantity);
        }
    }, [packages]);
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(checked, proposed) {
        if (checked && selectedIds.includes(data.id) && !isProposed(data.package)) {
            return;
        }
        if (checked) {
            appendPackage(data.package, proposed, quantity);
            selectedIds.push(data.id);
            setPackageQuantity(quantity);
        }
        else {
            removePackage(data.package);
            selectedIds = selectedIds.filter((id) => id !== data.id);
            setPackageQuantity(0);
        }
        setRequiredOptions(data.package, checked);
    }
    /**
     * @function isProposed
     * @since 1.0.0
     * @hidden
     */
    function isProposed(item) {
        const pack = packages.find((entry) => entry.package.id == item.id);
        if (pack == null) {
            return false;
        }
        return pack.proposed;
    }
    /**
     * @function onTypeChange
     * @since 1.0.0
     * @hidden
     */
    function onTypeChange(item, proposed) {
        const isSelected = packages.find((pack) => pack.package.id === item.id);
        if (isSelected) {
            removePackage(item);
            appendPackage(item, proposed, isSelected.quantity);
        }
        if (proposed) {
            onChange(true, true);
        }
        else {
            onChange(true, false);
        }
    }
    /**
     * @function onQuantityChange
     * @since 1.0.0
     * @hidden
     */
    function onQuantityChange(item, qty) {
        //if (parseInt(qty) !== packageQuantity) {
        setQuantityAlert(true); // TODO : We no longer have this state for now
        //}
        setPackageQuantity(parseInt(qty));
    }
    /**
     * @function onQuantityBlur
     * @since 1.0.0
     * @hidden
     **/
    function onQuantityBlur(item, qty) {
        /**
         * @function execute
         * @hidden
         * @since 1.0.0
         */
        function execute(makeChange) {
            const isSelected = packages.find((pack) => pack.package.id === item.id);
            if (isSelected) {
                removePackage(item);
                appendPackage(item, isSelected.proposed, makeChange ? parseInt(qty) : quantity);
            }
            else {
                if (parseInt(qty) > 0) {
                    appendPackage(item, false, makeChange ? parseInt(qty) : quantity);
                }
            }
        }
        if (quantityAlert) {
            /*modal.present({
              style: 'dialog',
              title: t('Update quantity'),
              picto: 'edit',
              modal: (
                <Confirm
                  title={`${t(
                    'You are about to change the quantity that is different from the product quantity. Are you sure you want to continue?'
                  )}`}
                  infos={t(
                    'Selecting "Yes" will update the quantity of the package. Selecting "No" will cancel the update.'
                  )}
                  acceptText={t('Yes')}
                  refuseText={t('No')}
                  onAccept={() => {
                    execute(true);
                  }}
                  onRefuse={() => {
                    execute(false);
                  }}
                />
              )
            });*/
            execute(true);
        }
        else {
            execute(true);
        }
    }
    /**
     * @function setRequiredOptions
     * @since 1.0.0
     * @hidden
     */
    function setRequiredOptions(data, checked) {
        var _a;
        const requiredOptions = (_a = data === null || data === void 0 ? void 0 : data.saleItems) === null || _a === void 0 ? void 0 : _a.filter((option) => option.required);
        if (requiredOptions) {
            requiredOptions.forEach((option) => {
                var _a;
                if (checked) {
                    appendOption(option.item, (_a = option.item.price) !== null && _a !== void 0 ? _a : 0, true, false, false, 1);
                }
                else {
                    removeOption(option.item);
                }
            });
        }
    }
    /**
     * @function onAlternativeSelect
     * @since 1.0.0
     * @hidden
     */
    function onAlternativeSelect(value, check) {
        var _a, _b;
        if (check) {
            const alternativeQuantity = (_b = (_a = packages.find((pack) => pack.package.id === alternativeTo)) === null || _a === void 0 ? void 0 : _a.quantity) !== null && _b !== void 0 ? _b : quantity;
            appendPackage(value.package, true, alternativeQuantity, alternativeTo);
            setCurrentSelections([...currentSelections, value.package.id]);
        }
        else {
            removePackage(value.package);
            setCurrentSelections(currentSelections.filter((id) => id !== value.package.id));
        }
    }
    /**
     * @function onViewMorePress
     * @since 1.0.0
     * @hidden
     */
    function onViewMorePress() {
        var _a;
        modal.present({
            style: 'detail-small',
            title: (_a = data.package.sku) !== null && _a !== void 0 ? _a : t('Package details'),
            picto: 'circle-info',
            modal: (React.createElement(DealItemPickerPackageDetail, { data: data.package, appendPackage: appendPackage }))
        });
    }
    const selected = packages.find((entry) => entry.package.id == data.id && entry.quantity > 0) != null;
    const options = data.package.saleItems
        ? data.package.saleItems.slice(0, 3)
        : [];
    const className = classNames('deal-item-picker-package-item', 'deal-item-picker-package-item--' + style, { 'deal-item-picker-package-item--is-selected': selected }, { 'deal-item-picker-package-item--no-icon': !data.package.icon }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { onClick: () => onChange(!selectedIds.includes(data.package.id), false) },
            React.createElement("div", { className: "deal-item-picker-package-item-head" },
                React.createElement("div", { className: "deal-item-picker-package-item-infos" },
                    React.createElement(Text, { className: "deal-item-picker-package-item-sku", value: data.package.sku }),
                    data.package.icon && (React.createElement(Icon, { className: "deal-item-picker-package-item-picto", value: data.package.icon }))),
                React.createElement(Text, { className: "deal-item-picker-package-item-title", value: data.package.title }),
                React.createElement(Money, { className: "deal-item-picker-package-item-price", value: calculatePriceCurrency(data.package.price, deal === null || deal === void 0 ? void 0 : deal.currency) })),
            React.createElement("div", { className: "deal-item-picker-package-item-body" },
                React.createElement("div", { dangerouslySetInnerHTML: { __html: data.package.infos } }),
                React.createElement("ul", { className: "deal-item-picker-package-item-options" }, options === null || options === void 0 ? void 0 : options.filter((o) => !o.required).map((option) => (React.createElement("li", { key: option.item.id, className: "deal-item-picker-package-item-option" }, option.item.title))))),
            data.package.saleItems && data.package.saleItems.length > 3 && (React.createElement("div", { className: "deal-item-picker-package-item-foot" },
                React.createElement(Button, { className: "deal-item-picker-package-pane-item-more", style: "upper", label: t('View more'), onPress: onViewMorePress })))),
        !alternativeTo && (React.createElement(FormGroup, null,
            (quantityType === 'GRANULAR' ||
                quantityType === 'ITEM_CONFIGURATION') && (React.createElement(FormInput, { className: "deal-item-picker-package-item-quantity", name: "quantity", label: t('Quantity'), type: "number", value: packageQuantity.toString(), onFocus: () => onChange(true, false), onChange: (value) => {
                    onQuantityChange(data.package, value);
                }, onBlur: (value) => {
                    onQuantityBlur(data.package, value);
                }, size: "small" })),
            React.createElement("div", { className: "deal-item-picker-package-item-actions" },
                React.createElement(FormIconCheckBox, { checked: isProposed(data.package), checkedIcon: "heart-circle-check", uncheckedIcon: "heart", onChange: (checked) => onTypeChange(data.package, checked) }),
                React.createElement(FormIconCheckBox, { checked: selectedIds.includes(data.package.id) &&
                        !isProposed(data.package), checkedColor: "secondary", checkedIcon: "fal check", uncheckedIcon: "fal plus", onChange: (checked) => onChange(checked, false) })))),
        alternativeTo && (React.createElement(FormIconCheckBox, { className: "table-row-image", checked: currentSelections.includes(data.package.id), checkedColor: "secondary", checkedIcon: "fal check", uncheckedIcon: "fal plus", onChange: (check) => {
                onAlternativeSelect(data, check);
            }, disabled: selectedIds.includes(data.package.id) &&
                !currentSelections.includes(data.package.id) }))));
}
